import { TextField, Typography, Button } from '@material-ui/core';
import Connector from 'connect-store';
import * as React from 'react';
import {
    createNewVirtualGroup,
    getVirtualGroupData,
    updateEnableOverageLimit,
    updateOverageLimitCount,
} from '../../api/operation/geojson';
import BacklogPointLoader from '../../classes/loaders/BacklogPointLoader';
import jsonToMap from '../../utils/jsonToMap';
import { BacklogPoint } from '../popUp/BacklogPoint';
import { SingleInput } from '../SingleInput';
import Switch from 'mango-ui/control/Switch';
const backlogPointLoader = new BacklogPointLoader();

const style = require('./style.less');

// 独立的停车区编辑组件（类组件），用于解决中文输入问题
class ParkingLotEditor extends React.Component<any, any> {
  constructor(props: any) {
    super(props);
    const { geometryInfo } = props;
    this.state = {
      localName: geometryInfo.name || '',
      localSort: geometryInfo.sort || 999  // 初始值可以是数字或字符串
    };
  }

  // 当 props 变化时，同步到本地 state
  componentDidUpdate(prevProps: any) {
    const { geometryInfo } = this.props;
    if (prevProps.geometryInfo._id !== geometryInfo._id ||
        prevProps.geometryInfo.name !== geometryInfo.name ||
        prevProps.geometryInfo.sort !== geometryInfo.sort) {
      this.setState({
        localName: geometryInfo.name || '',
        localSort: geometryInfo.sort || 999  // 保持与初始化一致
      });
    }
  }

  render() {
    const { geometryInfo, onUpdateParkingName, onUpdateParkingNameAndSave,
            onUpdateParkingSort, onUpdateParkingSortAndSave } = this.props;
    const { localName, localSort } = this.state;

    return (
      <>
        <p className={style.detail}>
          <span className={style.prop}>停车区名称:</span>
          <TextField
            style={{ textAlign: 'center', marginLeft: 5 }}
            value={localName}
            onChange={(e: any) => {
              // 本地 state 立即更新，支持中文输入
              this.setState({ localName: e.target.value });
            }}
            onBlur={(e: any) => {
              // 失焦时同步到 store
              onUpdateParkingName(e.target.value);
            }}
          />
          <Button
            disabled={localName === (geometryInfo.oldName || '')}
            size={'small'}
            variant="contained"
            onClick={() => onUpdateParkingNameAndSave(geometryInfo._id, localName)}
          >保存修改</Button>
        </p>
        <p className={style.detail}>
          <span className={style.prop}>排序:</span>
          <TextField
            type="number"
            style={{ textAlign: 'center', marginLeft: 5, width: 80 }}
            value={localSort}
            onChange={(e: any) => {
              // 本地 state 立即更新，允许空值
              const inputValue = e.target.value;
              // 如果是空字符串，保持为空；否则转换为数字或保持原值
              const value = inputValue === '' ? '' : (parseInt(inputValue, 10) || localSort);
              this.setState({ localSort: value });
            }}
            onBlur={(e: any) => {
              // 失焦时，如果是空值则设为默认值999，然后同步到 store
              const finalValue = e.target.value === '' ? 999 : parseInt(e.target.value, 10) || 999;
              this.setState({ localSort: finalValue });
              onUpdateParkingSort(String(finalValue));
            }}
          />
          <Button
            disabled={localSort === (geometryInfo.oldSort || 999)}
            size={'small'}
            variant="contained"
            onClick={() => {
              // 点击保存时，确保使用有效的数字值
              const finalSort = localSort === '' ? 999 : localSort;
              onUpdateParkingSortAndSave(geometryInfo._id, finalSort, localName);
            }}
          >保存修改</Button>
        </p>
      </>
    );
  }
}

// 虚拟分组名称编辑组件，解决中文输入问题
class VirtualGroupNameEditor extends React.Component<any, any> {
  constructor(props: any) {
    super(props);
    const { virtualGroupForm } = props;
    this.state = {
      localName: virtualGroupForm.name || '未命名合并分区'
    };
  }

  // 当 props 变化时，同步到本地 state
  componentDidUpdate(prevProps: any) {
    const { virtualGroupForm } = this.props;
    // 只有当virtualGroupForm._id变化时才同步（避免自己的更新触发）
    if (prevProps.virtualGroupForm._id !== virtualGroupForm._id) {
      this.setState({
        localName: virtualGroupForm.name || '未命名合并分区'
      });
    }
  }

  render() {
    const { onUpdateVirtualGroupForm } = this.props;
    const { localName } = this.state;

    return (
      <TextField
        style={{ textAlign: 'center', marginLeft: 5 }}
        value={localName}
        onChange={(e: any) => {
          // 本地 state 立即更新，支持中文输入
          this.setState({ localName: e.target.value });
        }}
        onBlur={(e: any) => {
          // 失焦时同步到 store
          onUpdateVirtualGroupForm({ name: e.target.value });
        }}
      />
    );
  }
}

// 虚拟分组排序编辑组件
class VirtualGroupSortEditor extends React.Component<any, any> {
  constructor(props: any) {
    super(props);
    const { virtualGroupForm } = props;
    this.state = {
      localSort: virtualGroupForm.sort || 999
    };
  }

  // 当 props 变化时，同步到本地 state
  componentDidUpdate(prevProps: any) {
    const { virtualGroupForm } = this.props;
    if (prevProps.virtualGroupForm._id !== virtualGroupForm._id ||
        prevProps.virtualGroupForm.sort !== virtualGroupForm.sort) {
      this.setState({
        localSort: virtualGroupForm.sort || 999
      });
    }
  }

  render() {
    const { virtualGroupForm, onUpdateVirtualGroupForm, onSaveVirtualGroupSort } = this.props;
    const { localSort } = this.state;

    return (
      <>
        <TextField
          type="number"
          style={{ textAlign: 'center', marginLeft: 5, width: 80 }}
          value={localSort}
          onChange={(e: any) => {
            // 本地 state 立即更新，允许空值
            const inputValue = e.target.value;
            const value = inputValue === '' ? '' : (parseInt(inputValue, 10) || localSort);
            this.setState({ localSort: value });
          }}
          onBlur={(e: any) => {
            // 失焦时，如果是空值则设为默认值999，然后同步到 store
            const finalValue = e.target.value === '' ? 999 : parseInt(e.target.value, 10) || 999;
            this.setState({ localSort: finalValue });
            onUpdateVirtualGroupForm({ sort: finalValue });
          }}
        />
        <Button
          disabled={localSort === (virtualGroupForm.oldSort || 999)}
          size={'small'}
          variant="contained"
          onClick={() => {
            // 点击保存时，确保使用有效的数字值
            const finalSort = localSort === '' ? 999 : localSort;
            onSaveVirtualGroupSort(virtualGroupForm._id, finalSort, virtualGroupForm.name);
          }}
        >保存修改</Button>
      </>
    );
  }
}

export interface IGeometryInfo {
  geometryInfo: IObject;
  multiPolygonSelector: string[];
  virtualGroupForm: Record<string, any>;
  isEditBacklogPoint: boolean;
  adjustmentRemark: string;
  onChangeAdjustmentRemark: IFunction;
  onAuditAdjustmentRemark: IFunction;
  onUpdateRatedParkingCapacity: IFunction;
  onUpdateHasBluetoothSpike: IFunction;
  onUpdateEnableOverageLimit: IFunction;
  onUpdateOverageLimitCount: IFunction;
  onClearVirtualGroupLink: IFunction;
  onUpdateVirtualGroupForm: IFunction;
  onUpdateStockBelowAlarmCount: IFunction;
  onUpdateStockBacklogAlarmCount: IFunction;
  createVirtualGroup: IFunction;
  editVirtualGroup: IFunction;
  loadVirtualGroups: IFunction;
  onUpdateParkingName: IFunction;
  onUpdateParkingNameAndSave: IFunction;
  onUpdateParkingSort: IFunction;
  onUpdateParkingSortAndSave: IFunction;
  onSaveVirtualGroupSort: IFunction;
}

export default ({
  geometryInfo, isEditBacklogPoint, multiPolygonSelector, virtualGroupForm, loadVirtualGroups,
  adjustmentRemark, onChangeAdjustmentRemark, onAuditAdjustmentRemark,
  onUpdateRatedParkingCapacity, onUpdateHasBluetoothSpike, onUpdateEnableOverageLimit, onUpdateOverageLimitCount, onUpdateStockBacklogAlarmCount,  onUpdateStockBelowAlarmCount,
  onUpdateVirtualGroupForm, createVirtualGroup, editVirtualGroup, onClearVirtualGroupLink, onUpdateParkingName, onUpdateParkingNameAndSave,
  onUpdateParkingSort, onUpdateParkingSortAndSave, onSaveVirtualGroupSort
}: IGeometryInfo) => {
  const OP_PARKING_LOT_REVIEW_STATE = (window as any).constants.OP_PARKING_LOT_REVIEW_STATE;
  const OP_PARKING_LOT_REVIEW_STATE_MAP = jsonToMap(OP_PARKING_LOT_REVIEW_STATE);
  const OP_ROAD_NET_ROAD_TYPE_MAP = (window as any).constants.OP_ROAD_NET_ROAD_TYPE_MAP;
  const OP_PARKING_ADJUSTMENT_WAY = (window as any).constants.OP_PARKING_ADJUSTMENT_WAY;
  const OP_PARKING_ADJUSTMENT_WAY_MAP = jsonToMap(OP_PARKING_ADJUSTMENT_WAY);
  const OP_PARKING_ADJUSTMENT_ITEMS = (window as any).constants.OP_PARKING_ADJUSTMENT_ITEMS;
  const OP_PARKING_ADJUSTMENT_ITEMS_MAP = jsonToMap(OP_PARKING_ADJUSTMENT_ITEMS);
  if (multiPolygonSelector && multiPolygonSelector.length) {
      const regionIds = new Set();
      const virtualGroupRegionIds: Set<string> = new Set();
      const polygons = multiPolygonSelector.map(polygon => {
          const record: Record<string, any> = JSON.parse(polygon);
          regionIds.add(record.region._id);
          if (record.regionGroupId) {
              virtualGroupRegionIds.add(record.regionGroupId);
          }
          return record;
      });
      const isSameRegion = regionIds.size === 1;
      const actionType = !virtualGroupRegionIds.size ? 'create' : ( virtualGroupRegionIds.size > 1 ? 'replace' : 'update' );
      if (virtualGroupRegionIds.size === 1 && virtualGroupForm._id !== Array.from(virtualGroupRegionIds)[0]) {
          getVirtualGroupData(Array.from(virtualGroupRegionIds)[0]).then(res => {
              onUpdateVirtualGroupForm({
                  _id: res.data._id,
                  name: res.data.name || '未命名合并分区',
                  enableOverageLimit: res.data.enableOverageLimit,
                  overageLimitCount: res.data.overageLimitCount,
                  stockBelowAlarmCount: res.data.stockBelowAlarmCount,
                  stockBacklogAlarmCount: res.data.stockBacklogAlarmCount,
                  sort: res.data.sort || 999,
                  oldSort: res.data.sort || 999,
              });
          });
      }
      return (
          <div className={style.container}>
              <h2 className={style.title}>预留车辆分组配置</h2>
              {
                  isSameRegion ? [
                      // tslint:disable-next-line:jsx-key
                      <p className={style.detail}>
                          <span className={style.prop}>分组名称:</span>
                          <span>
                              <VirtualGroupNameEditor
                                  virtualGroupForm={virtualGroupForm}
                                  onUpdateVirtualGroupForm={onUpdateVirtualGroupForm}
                              />
                          </span>
                      </p>,
                      // tslint:disable-next-line:jsx-key
                      <p className={style.detail}>
                          <span className={style.prop}>排序:</span>
                          <span>
                              <VirtualGroupSortEditor
                                  virtualGroupForm={virtualGroupForm}
                                  onUpdateVirtualGroupForm={onUpdateVirtualGroupForm}
                                  onSaveVirtualGroupSort={onSaveVirtualGroupSort}
                              />
                          </span>
                      </p>,
                      // tslint:disable-next-line:jsx-key
                      <p className={style.detail}>
                          <span className={style.prop}>已选择:</span>
                          <span>{multiPolygonSelector.length}个分区</span>
                      </p>,
                      // tslint:disable-next-line:jsx-key
                      <p className={style.detail}>
                          <span className={style.prop}>是否启用保留车辆:</span>
                          <Switch
                              active={virtualGroupForm.enableOverageLimit}
                              onToggle={async (value: boolean) => {
                                  onUpdateVirtualGroupForm({ enableOverageLimit: value });
                              }}
                          />
                      </p>,
                      // tslint:disable-next-line:jsx-key
                      <p className={style.detail}>
                          <span className={style.prop}>保留车辆数量:</span>
                          <span style={{paddingRight: '10px'}}>{virtualGroupForm.overageLimitCount || 0}</span>
                          <SingleInput
                              resetAfterDone={true}
                              style={{ width: 50 }}
                              name={virtualGroupForm._id}
                              defaultValue={''}
                              onDone={async (value: string) => {
                                  // tslint:disable-next-line:radix
                                  onUpdateVirtualGroupForm({ overageLimitCount: parseInt(value || '-1') });
                              }}
                          />
                      </p>,
                      <p className={style.detail}>
                          <span className={style.prop}>小于多少台车触发告警:</span>
                          <span style={{paddingRight: '10px'}}>{virtualGroupForm.stockBelowAlarmCount || -1}</span>
                          <SingleInput
                              resetAfterDone={true}
                              style={{ width: 50 }}
                              name={geometryInfo._id}
                              defaultValue={''}
                              onDone={async (value: string) => {
                                  // tslint:disable-next-line:radix
                                  onUpdateVirtualGroupForm({ stockBelowAlarmCount: parseInt(value || '-1') });
                              }}
                          />
                      </p>,
                      <p className={style.detail}>
                          <span className={style.prop}>大于多少辆车触发积压告警:</span>
                          <span style={{paddingRight: '10px'}}>{virtualGroupForm.stockBacklogAlarmCount || -1}</span>
                          <SingleInput
                              resetAfterDone={true}
                              style={{ width: 50 }}
                              name={geometryInfo._id}
                              defaultValue={''}
                              onDone={async (value: string) => {
                                  // tslint:disable-next-line:radix
                                  onUpdateVirtualGroupForm({ stockBacklogAlarmCount: parseInt(value || '-1') });
                              }}
                          />
                      </p>,
                      // tslint:disable-next-line:jsx-key
                      <p className={style.detail}>
                          <span className={style.prop}>操作:</span>
                          <span>
                              {/* tslint:disable-next-line:jsx-alignment */}
                              <button onClick={() => {
                                  const action = actionType === 'update' ? editVirtualGroup : createVirtualGroup;
                                  action(Array.from(new Set(polygons.map(record => record._id))), Array.from(regionIds)[0]);
                                  // tslint:disable-next-line:jsx-alignment
                              }}>{actionType === 'create' ? '创建' : ( actionType === 'update' ? '保存' : '覆盖' )}</button>
                          </span>
                      </p>,
                  ] : <span>不在同一区域下,无法统一管理!</span>
              }
          </div>
      );
  } else if (geometryInfo) {
    const creatorName = geometryInfo.creator && geometryInfo.creator.cert && geometryInfo.creator.cert.name;
    const creatorTel = geometryInfo.creator && geometryInfo.creator.auth && geometryInfo.creator.auth.tel;
    const roadType = geometryInfo.roadType;
      switch (geometryInfo.layerType) {
      case 'roadNet':
        return (
          <div className={style.container}>
            <h2 className={style.title}>路网</h2>
              <p className={style.detail}>
                  <span className={style.prop}>ID:</span>
                  <span>{geometryInfo._id}</span>
              </p>
            <p className={style.detail}><span
              className={style.prop}
            >创建人:
            </span><span>{creatorName}</span></p>
            <p className={style.detail}>
              <span
                className={style.prop}
              >联系电话:
              </span><span>{creatorTel}</span></p>
            <p className={style.detail}><span
              className={style.prop}
            >路网长度:
            </span><span>{geometryInfo.length / 1000}公里</span></p>
            <p className={style.detail}><span
              className={style.prop}
            >路线类型:
            </span><span>{OP_ROAD_NET_ROAD_TYPE_MAP[roadType]}</span></p>
          </div>
        );
      case 'parkLot':
        return (geometryInfo || {})._id ? (
          <div className={style.container}>
            <h2 className={style.title}>停车区</h2>
              <p className={style.detail}>
                  <span className={style.prop}>ID:</span>
                  <span>{(geometryInfo || {})._id}</span>
              </p>
            <ParkingLotEditor
              geometryInfo={geometryInfo}
              onUpdateParkingName={onUpdateParkingName}
              onUpdateParkingNameAndSave={onUpdateParkingNameAndSave}
              onUpdateParkingSort={onUpdateParkingSort}
              onUpdateParkingSortAndSave={onUpdateParkingSortAndSave}
            />
            <p className={style.detail}>
              <span className={style.prop}>是否有蓝牙道钉:</span>
              <Switch
                active={geometryInfo.hasBluetoothSpike}
                onToggle={async (value: Boolean) => {
                  await onUpdateHasBluetoothSpike(geometryInfo._id, value);
                }}
              />
            </p>
            <p className={style.detail}>
              <span className={style.prop}>额定容量:</span>
              <span>{geometryInfo.ratedCapacity}</span>
            </p>
            <p className={style.detail}>
              <span className={style.prop}>剩余容量:</span>
              <span>{geometryInfo.restCapacity}</span>
            </p>
            <p className={style.detail}>
              <span className={style.prop}>调度系统额定容量:</span>
              <span style={{paddingRight: '10px'}}>{geometryInfo.ratedParkingCapacity}</span>
              <SingleInput
                resetAfterDone={true}
                style={{ width: 50 }}
                name={geometryInfo._id}
                defaultValue={''}
                onDone={async (value: string) => {
                  await onUpdateRatedParkingCapacity(geometryInfo._id, value);
                }}
              />
            </p>
            <p className={style.detail}>
              <span className={style.prop}>调度系统剩余容量:</span>
              <span>{geometryInfo.remainingCapacity}</span>
            </p>
              <p className={style.detail}>
                  <span className={style.prop}>大区:</span>
                  <span>{((geometryInfo || {}).region || {}).name}</span>
              </p>
              {
                 geometryInfo.regionGroupId ?
                      <p className={style.detail}>
                          <span className={style.prop}>已绑定虚拟管理群组:</span>
                          <span><button onClick={() => loadVirtualGroups(geometryInfo.regionGroupId)}>查看</button><button onClick={async () => await onClearVirtualGroupLink(geometryInfo._id)}>解绑</button></span>
                      </p> : [
                          <p className={style.detail}>
                              <span className={style.prop}>是否启用保留车辆:</span>
                              <Switch
                                  active={geometryInfo.enableOverageLimit}
                                  onToggle={async (value: Boolean) => {
                                      await onUpdateEnableOverageLimit(geometryInfo._id, value);
                                  }}
                              />
                          </p>,
                          (
                              geometryInfo.enableOverageLimit ?
                                  <p className={style.detail}>
                                      <span className={style.prop}>保留车辆数量:</span>
                                      <span style={{paddingRight: '10px'}}>{geometryInfo.overageLimitCount || 0}</span>
                                      <SingleInput
                                          resetAfterDone={true}
                                          style={{ width: 50 }}
                                          name={geometryInfo._id}
                                          defaultValue={''}
                                          onDone={async (value: string) => {
                                              await onUpdateOverageLimitCount(geometryInfo._id, value);
                                          }}
                                      />
                                  </p>
                                  : null
                          ),
                          <p className={style.detail}>
                              <span className={style.prop}>小于多少台车触发告警:</span>
                              <span style={{paddingRight: '10px'}}>{geometryInfo.stockBelowAlarmCount || -1}</span>
                              <SingleInput
                                  resetAfterDone={true}
                                  style={{ width: 50 }}
                                  name={geometryInfo._id}
                                  defaultValue={''}
                                  onDone={async (value: string) => {
                                      await onUpdateStockBelowAlarmCount(geometryInfo._id, value);
                                  }}
                              />
                          </p>,
                          <p className={style.detail}>
                              <span className={style.prop}>大于多少辆车触发积压告警:</span>
                              <span style={{paddingRight: '10px'}}>{geometryInfo.stockBacklogAlarmCount || -1}</span>
                              <SingleInput
                                  resetAfterDone={true}
                                  style={{ width: 50 }}
                                  name={geometryInfo._id}
                                  defaultValue={''}
                                  onDone={async (value: string) => {
                                      await onUpdateStockBacklogAlarmCount(geometryInfo._id, value);
                                  }}
                              />
                          </p>,
                      ]
              }
            <p className={style.detail}><span
              className={style.prop}
            >审核状态:
            </span><span>{OP_PARKING_LOT_REVIEW_STATE_MAP[geometryInfo.reviewState]}</span>
            </p>
            <p className={style.detail}><span
              className={style.prop}
            >创建人:
            </span><span>{creatorName}</span></p>
            <p className={style.detail}><span
              className={style.prop}
            >联系电话:
            </span><span>{creatorTel}</span></p>
          </div>
        ) : (<div>点击空白处再重新点击停车区</div>);
      case 'region':
        return (
          <div className={style.container}>
            <h2 className={style.title}>大区</h2>
              <p className={style.detail}>
                  <span className={style.prop}>ID:</span>
                  <span>{geometryInfo._id}</span>
              </p>
            <p className={style.detail}><span
              className={style.prop}
            >大区名称:
            </span><span>{geometryInfo.name}</span></p>
            <p className={style.detail}><span
              className={style.prop}
            >创建人:
            </span><span>{creatorName}</span></p>
            <p className={style.detail}><span
              className={style.prop}
            >联系电话:
            </span><span>{creatorTel}</span></p>
          </div>
        );
      case 'pointToMeasure':
        return (
          <div className={style.container}>
              <p className={style.detail}>
                  <span className={style.prop}>ID:</span>
                  <span>{geometryInfo._id}</span>
              </p>
            <h2 className={style.title}>测量点</h2>
            <p>路网长度:{geometryInfo.length}</p>
            <p className={style.detail}><span
              className={style.prop}
            >创建人:
            </span><span>{creatorName}</span></p>
            <p className={style.detail}><span
              className={style.prop}
            >联系电话:
            </span><span>{creatorTel}</span></p>
          </div>
        );
      case 'pointToPhoto':
        return (
          <div className={style.container}>
            <h2 className={style.title}>照片点</h2>
              <p className={style.detail}>
                  <span className={style.prop}>ID:</span>
                  <span>{geometryInfo._id}</span>
              </p>
            <p className={style.detail}><span
              className={style.prop}
            >创建人:
            </span><span>{creatorName}</span></p>
            <p className={style.detail}><span
              className={style.prop}
            >联系电话:
            </span><span>{creatorTel}</span></p>
          </div>
        );
      case 'prohibitedArea':
        const address = geometryInfo.location.address;
        const city = geometryInfo.location.city;
        const area = geometryInfo.location.area;

        return (
          <div className={style.container}>
            <h2 className={style.title}>禁行区</h2>
              <p className={style.detail}>
                  <span className={style.prop}>ID:</span>
                  <span>{geometryInfo._id}</span>
              </p>
            <p className={style.detail}><span
              className={style.prop}
            >地址:
            </span><span>{city}{area}{address}</span>
            </p>
            <p className={style.detail}><span
              className={style.prop}
            >创建人:
            </span><span>{creatorName}</span></p>
            <p className={style.detail}><span
              className={style.prop}
            >联系电话:
            </span><span>{creatorTel}</span></p>
          </div>
        );
      case 'inspectionArea':
        return (
          <div className={style.container}>
            <h2 className={style.title}>巡检区</h2>
              <p className={style.detail}>
                  <span className={style.prop}>ID:</span>
                  <span>{geometryInfo._id}</span>
              </p>
            <p className={style.detail}><span>巡检区名称:</span><span>{geometryInfo.name}</span></p>
            <p className={style.detail}><span>创建人:</span><span>{creatorName}</span></p>
            <p className={style.detail}><span>联系电话:</span><span>{creatorTel}</span></p>
          </div>
        );
      case 'backlogPoint':
        if (isEditBacklogPoint) {
          return (
            <div className={style.container} style={{ background: 'white' }}>
              <h2 className={style.title}>积压点</h2>
              <BacklogPoint
                other={geometryInfo._id}
                callback={backlogPointLoader.update.bind(backlogPointLoader)}
                properties={geometryInfo._id}
              />
            </div>
          );
        } else {
          return (
            <div className={style.container}>
              <h2 className={style.title}>积压点</h2>
                <p className={style.detail}><span>ID:</span><span>{geometryInfo._id}</span></p>
              <p className={style.detail}><span>名称:</span><span>{geometryInfo.name}</span></p>
              <p className={style.detail}><span>警戒数:</span><span>{geometryInfo.warningNumber}</span>
              </p>
              <p className={style.detail}>
                <span>实际车辆数:</span><span>{geometryInfo.actualStockNumber}</span></p>
              <p className={style.detail}><span>半径:</span><span>{geometryInfo.radius}</span></p>
              <p className={style.detail}><span>状态:</span><span>{geometryInfo.state}</span></p>
              <p className={style.detail}>
                <span>修改人:</span><span>{geometryInfo.modifier && geometryInfo.modifier.cert.name}</span>
              </p>
              <p className={style.detail}>
                <span>修改人联系电话:</span><span>{geometryInfo.modifier && geometryInfo.modifier.auth.tel}</span>
              </p>
              <p className={style.detail}>
                <span>修改时间:</span><span>{new Date(geometryInfo.updatedAt).toLocaleDateString()}</span>
              </p>
              <p className={style.detail}><span>创建人:</span><span>{creatorName}</span></p>
              <p className={style.detail}>
                <span>创建时间:</span><span>{new Date(geometryInfo.createdAt).toLocaleDateString()}</span>
              </p>
              <p className={style.detail}><span>创建人联系电话:</span><span>{creatorTel}</span></p>
            </div>
          );
        }
      case 'adjustment':
        return (
          <div className={style.container}>
            <div style={{ display: 'flex' }}>
              <h2
                style={{ flex: 1, fontWeight: 700 }}>{OP_PARKING_ADJUSTMENT_WAY_MAP[geometryInfo.adjustmentWay]}</h2>
              <h2
                style={{ flex: 1, textAlign: 'right', fontWeight: 700 }}>{OP_PARKING_ADJUSTMENT_ITEMS_MAP[geometryInfo.state]}</h2>
            </div>
              <p className={style.detail}>
                  <span className={style.prop}>ID:</span>
                  <span>{geometryInfo._id}</span>
              </p>
            <p className={style.detail}>
              <span>提报人</span>
              <span>{geometryInfo.inspector && geometryInfo.inspector.cert.name}</span>
              <span>{geometryInfo.inspector && geometryInfo.inspector.auth.tel}</span>
            </p>
            <p className={style.detail}>
              <span>{new Date(geometryInfo.createdAt).toLocaleDateString()}</span>
            </p>
            <p className={style.detail}>
              <span>{geometryInfo.location.address}</span>
            </p>
            <p className={style.detail}>
              <span>备注：</span>
              <span>{geometryInfo.description}</span>
            </p>
            <p>
              {
                geometryInfo.photos.map((photo: any) => {
                  return <img src={photo} alt="" width={100} height={100}/>;
                })
              }
            </p>
            {
              geometryInfo.state === OP_PARKING_ADJUSTMENT_ITEMS.待处理 ? (
                <p>
                  <span>处理方式：</span>
                  <span>
                    <textarea onChange={(e: any) => onChangeAdjustmentRemark(e.target.value)}/>
                    <button
                      style={{ marginRight: 3 }}
                      onClick={() => onAuditAdjustmentRemark(geometryInfo._id, adjustmentRemark)}
                    >
                      提交
                    </button>
                  </span>
                </p>
              ) : (
                <p>
                  <span>处理人：</span>
                  <span>{geometryInfo.processInfo && geometryInfo.processInfo.auditor && geometryInfo.processInfo.auditor.cert.name}</span>
                  <span>{geometryInfo.processInfo && geometryInfo.processInfo.auditor && geometryInfo.processInfo.auditor.auth.tel}</span>
                  <p className={style.detail}>
                    <span>{new Date(geometryInfo.processInfo && geometryInfo.processInfo.auditTime).toLocaleDateString()}</span>
                  </p>
                  <p className={style.detail}>
                    <span>处理方式：</span>
                    <span>{geometryInfo.processInfo && geometryInfo.processInfo.remark}</span>
                  </p>
                </p>
              )
            }
          </div>
        );
      default:
        return (
          <div className={style.container}>
            <h2 className={style.title}>点击图形展示相应的信息</h2>
          </div>
        );
    }
  } else {
    return (
      <div className={style.container}>
        <h2 className={style.title}>图形信息</h2>
        <div style={{ textAlign: 'center' }}>选中图形后展示相应信息</div>
      </div>
    );
  }

};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1-0!./src/views/graphInfoPanelView/GraphInfoPanelView.tsx